export default "__VITE_ASSET__CVloIfRf__"